<div *ngIf="condition">
    {{ message }}
</div>